import React from 'react'
import { Button } from '@fortressiq/fiq-ds'

const RefreshTableButton = ({ handleReFetch }) => {
  return (
    <Button
      type='default'
      key='refresh-table'
      icon='refresh'
      onClick={() => handleReFetch()}
      className='refreshTableBtn'
      title='Refresh Table'
    />
  )
}

export default RefreshTableButton
